import { Link } from 'react-router-dom';
import { FiEdit3, FiTrash2 } from 'react-icons/fi';

const RoleEditMenu = ({ role, onRemove }) => {
  return (
    <div className="d-flex">
      <Link to={`/admin/roles/edit/${role.id}`} className="btn-link">
        <FiEdit3 size={22} />
      </Link>
      <button className="btn p-0 btn-link ms-3" onClick={onRemove}>
        <FiTrash2 size={22} />
      </button>
    </div>
  );
};

export default RoleEditMenu;
